import React from 'react';
import { getRootUrl } from '@utils/urlHelpers.util';
import { UniversalFooterLink } from './Footer.styles';
import { useTranslation } from 'react-i18next';

interface FooterMenu {
  id: string;
}

export const FooterMenu: React.FC<FooterMenu> = ({ id }) => {
  const { t } = useTranslation('header');

  return (
    <>
      <UniversalFooterLink
        id={`universalFooterShipping${id}`}
        href={getRootUrl('/shipping-policy')}
        variant="footer"
        typography="featureCopy17"
      >
        {t('footer.shipping')}
      </UniversalFooterLink>
      <UniversalFooterLink
        id={`universalFooterReturns${id}`}
        href={getRootUrl('/return-policy')}
        variant="footer"
        typography="featureCopy17"
      >
        {t('footer.returns')}
      </UniversalFooterLink>
      <UniversalFooterLink id={`universalFooterNewsroom${id}`} href={'/newsroom/'} variant="footer" typography="featureCopy17">
        {t('footer.newsroom')}
      </UniversalFooterLink>
      <UniversalFooterLink id={`universalFooterCareers${id}`} href={getRootUrl('/careers/')} variant="footer" typography="featureCopy17">
        {t('footer.careers')}
      </UniversalFooterLink>
      <UniversalFooterLink id={`universalFooterAboutJoy${id}`} href={getRootUrl('/our-story/')} variant="footer" typography="featureCopy17">
        {t('footer.aboutJoy')}
      </UniversalFooterLink>
      <UniversalFooterLink id={`universalFooterContactUs${id}`} href="mailto:hello@withjoy.com" variant="footer" typography="featureCopy17">
        {t('footer.contactUs')}
      </UniversalFooterLink>
    </>
  );
};
